// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"IpyOINs5pJmaMKyJ_xyz"};